'use client';;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:native-teams-frontend":true});}catch(e){}}();

import { Tooltip, TooltipContent, TooltipTrigger } from '@workspace/ui/components/tooltip';
import { useIsOverflowing } from '@workspace/ui/hooks';
import { cn } from '@workspace/ui/lib';
import type React from 'react';

interface TruncateWithTooltipProps {
  children: React.ReactNode;
  className?: string;
  contentClassName?: string;
}

export const TruncateWithTooltip = ({
  children,
  className,
  contentClassName,
}: TruncateWithTooltipProps) => {
  const { ref, overflowing } = useIsOverflowing<HTMLSpanElement>();

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <span ref={ref} className={cn('block min-w-0 truncate', className)}>
          {children}
        </span>
      </TooltipTrigger>
      {overflowing && (
        <TooltipContent className={cn('max-w-lg wrap-break-word px-3 py-2', contentClassName)}>
          {children}
        </TooltipContent>
      )}
    </Tooltip>
  );
};
